import { Component } from '@angular/core';
import { KeyValue } from '../../shared/key-value';
import { AuthorizationService } from '../../shared/authorization.service';
import {AngularTokenService} from '@lakshvairav/angular-token';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
// import { IndentStyle } from '../../../assets/js/indent.js'
import * as QuillNamespace from 'quill';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {map} from 'rxjs/operators';
const Quill: any = QuillNamespace
const Font = Quill.import('formats/font')
Font.whitelist =   ['sansserif','Aref Ruqaa', 'Mirza', 'monospace', 'Roboto', 'serif']
Quill.register(Font, true);
@Component({
	selector: 'text-editor',
  templateUrl: 'text-editor.component.html'
})

export class TextEditorComponent {
  editor_content: string;
  editor: any;
  image_attachments: any;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private http: HttpClient,private KeyValueService: KeyValue) {
    this.editor_content = '';
  }
  
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'size': ['10px', false, '18px', '32px'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font':  ['sansserif', 'Aref Ruqaa', 'Mirza', 'monospace', 'Roboto', 'serif']}],
      [{ 'align': [] }],
      ['clean'],
      ['link', 'image'] 
    ]
  };

  EditorCreated(quill){
    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', this.imageHandler.bind(this));
    this.editor = quill;
  }

  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
    Imageinput.classList.add('ql-image');
    Imageinput.addEventListener('change', () =>  {
    if (Imageinput.files != null && Imageinput.files[0] != null) {
      const { formData, headers } = this.constructImageRequest(Imageinput);
      this.http.post(environment.base_url + '/' + KeyValue.api_editor_attachment, formData, { headers }).pipe(map(res => JSON.parse(JSON.stringify(res)))).subscribe(
        data => {
          if (data.status === 200) {
            this.image_attachments = data.attachments;
            const url = environment.base_url +"/"+ data.current_file;
            this.pushImageToEditor(url);
          } else {
            KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' })
          }
        },
        error => {
          console.log(error);
        }
      );
      }
    });
    Imageinput && Imageinput.click();
  }

  constructImageRequest(input){
    const formData = new FormData();
    formData.append('uploadFile', input.files[0], input.files[0].name);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('enctype',"multipart/form-data")
    const hdrs = this._tokenService.currentAuthData;

    headers.append('accessToken',hdrs.accessToken );
    headers.append('client', hdrs.client);
    headers.append('tokenType', hdrs.tokenType);
    headers.append('uid', hdrs.uid);

    return { formData, headers };
  }

  pushImageToEditor(url) {
    const range = this.editor.getSelection(true);
    this.editor.insertEmbed(range.index, 'image', url)
  }
  
  ngAfterViewInit() {
    const toolbarElement = document.querySelector('.ql-toolbar');
    const tooltips = {
      'bold': 'Bold',
      'italic': 'Italic',
      'underline': 'Underline',
      'strike': 'Strikethrough',
      'blockquote':'Quote',
      'code-block': 'Code Block',
      'header': 'Text Style',
      'list' : 'List',
      'script':'Script',
      'indent': 'Indent',
      'direction': 'Direction',
      'size': 'Font Size',
      'color' : 'Text Color',
      'background': 'Background Color',
      'font': 'Font',
      'align': 'Align',
      'clean': 'Clear Format',
      'link': 'Link',
      'image': 'Image'
    };
    if (toolbarElement) {
			const matches = toolbarElement.querySelectorAll('button');
			for (let i = 0; i < matches.length; i++) {
				const tool = matches[i].className.replace('ql-', '');
				if (tooltips[tool]) {
					matches[i].setAttribute('title', tooltips[tool]);
				}
			}
			const selectMatches = toolbarElement.querySelectorAll('.ql-toolbar > span > span');
			for (let i = 0; i < selectMatches.length; i++) {
				const tool = selectMatches[i].classList && selectMatches[i].classList[0].replace('ql-', '');
				if (tooltips[tool]) {
					selectMatches[i].setAttribute('title', tooltips[tool]);
				}
			}
		}
  }
}
